import { Connector } from '../../common/redux/api/web-api'

function getInstallationPhases(connector: Connector | undefined): string | undefined {
    return connector?.installationPhaseMode?.replace('P', '')
}

export default getInstallationPhases
